import NetworkBar from './NetworkBar';
import NetworbarUi2 from './NetworkBar.networkbar_ui_2';
import NetworkBarContainer from './NetworkBar.container';
import { withFeatureBranch } from '../redux/flags';
export default NetworkBarContainer(withFeatureBranch({ networkbar_ui_2: NetworbarUi2 })(NetworkBar));
//# sourceMappingURL=index.js.map